
import { defineComponent } from 'vue'
import i18n from '@web/plugins/i18n'

import AsExternalDocument from '@web/components/AsExternalDocument.vue'

export default defineComponent({
  components: {
    AsExternalDocument
  },
  props: {
    docs: {
      type: Array,
      default: () => []
    },
    instructionUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: () => i18n.global.t('documents')
    },
    mobileAccess: {
      type: Boolean,
      default: true
    }
  }
})
